import { EyeOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import style from "./Article.module.css";
import React, { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import request from "../../common/request";
export default function Main() {
  const { id } = useParams();
  const [article, setArticle] = useState({});
  console.log(id);

  useEffect(() => {
    console.log("iii");
    request.getArticle(id).then(function (result) {
      console.log(result);
      setArticle(result.data.data);
    });
  }, [id]);

  return (
    <>
      <div className={style.articleBox}>
        <h1>{article.title}</h1>
        <p>
          <span>{article.created_at}</span>
          <span style={{ marginLeft: "50px" }}>
            <EyeOutlined /> {article.read_count}
          </span>
          <span
            className={style.back}
            style={{ float: "right" }}
            onClick={() => {
              window.history.back();
            }}
          >
            <ArrowLeftOutlined />
            返回上一页
          </span>
        </p>

        <div dangerouslySetInnerHTML={{ __html: article.content }} />

        <div className={style.prevAndNext}>
          <p>
            {article?.page_turning?.previous && (
              <Link to={`/article/` + article?.page_turning?.previous?.id}>
                上一篇： {article?.page_turning?.previous?.title}
              </Link>
            )}
          </p>
          <p>
            {article?.page_turning?.next && (
              <Link to={`/article/` + article?.page_turning?.next?.id}>
                下一篇： {article?.page_turning?.next?.title}
              </Link>
            )}
          </p>
        </div>
      </div>
    </>
  );
}
